module.exports = __webpack_public_path__ + "img/mottoImg1.99867881.jpg";